import { render, staticRenderFns } from "./Affiliation.vue?vue&type=template&id=b1d0a7b8&scoped=true"
import script from "./Affiliation.vue?vue&type=script&lang=js"
export * from "./Affiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d0a7b8",
  null
  
)

export default component.exports